import store from "../../../common/state/store";
import appNotificationStoreFactory from "../../../common/state/modules/appNotificationStoreFactory";
import interfaceStoreFactory from "./modules/interfaceStoreFactory";
import {VueRouter} from "vue-router/types/router";
import objectModelEntriesFactory from "~/state/modules/objectModelEntriesFactory";
import detailViewFactory from "./modules/detailViewFactory";
import entryBulkActionStoreFactory from "./modules/entryBulkActionStoreFactory"
import flashStoreFactory from "~/state/modules/flashStoreFactory";
import {IFlash} from "~/interfaces/flashInterfaces";
import breadcrumbStoreFactory from "~/state/modules/breadcrumbStoreFactory";
import IBreadcrumb from "~/interfaces/breadcrumbInterfaces";
import ObjectModelEntry from "~/models/objectModelEntries/objectModelEntry";
import noteStoreFactory from "./modules/noteStoreFactory";
import timezoneStoreFactory from "~/state/modules/timezoneStoreFactory";
import dashboardDrillDownStore from "./modules/dashboardDrillDownStore";
import { IDashboardFilters } from '~/interfaces/dashboardFilterInterfaces'

export default class StoreFactory {
  static registerModules(
    router: VueRouter,
    initialFlash: IFlash,
    breadcrumbs: Array<IBreadcrumb>,
    entry: ObjectModelEntry,
    handleChangesJobIds?: string[],
    timezone?: string,
    dashboardDrilldownFilters?: IDashboardFilters
  ) {
    store.registerModule('objectModelEntriesStore', objectModelEntriesFactory(router, handleChangesJobIds));
    store.registerModule('detailViewStore', detailViewFactory());
    store.registerModule('interfaceStore', interfaceStoreFactory());
    store.registerModule('appNotificationStore', appNotificationStoreFactory());
    store.registerModule('bulkActionStore', entryBulkActionStoreFactory());
    store.registerModule('flashStore', flashStoreFactory(initialFlash));
    store.registerModule('breadcrumbStore', breadcrumbStoreFactory(breadcrumbs));
    store.registerModule('noteStore', noteStoreFactory());
    store.registerModule('timezoneStore', timezoneStoreFactory(timezone));
    store.registerModule('dashboardDrillDownFiltersStore', dashboardDrillDownStore(dashboardDrilldownFilters))
  }
}
